<!-- This header is shown on top of every page after the login page, is used in layouts -->
<template>
  <v-app-bar app color="white" flat>
    <!-- HDN Logo -->
    <svg style="max-width: 47px; position: absolute; padding-top: 6px;" xmlns="http://www.w3.org/2000/svg" id="Laag_2" viewBox="0 0 580.08 745.2"
      class="attachment-full size-full replaced-svg">
      <defs></defs>
      <g id="Laag_1-2">
        <g>
          <path class="cls-1"
            d="m270.16,363.77H108.64S27.88,221.85,27.88,221.85L108.64,79.94h161.52l80.76,141.91-80.76,141.91Zm-160.52-1.76h159.52s79.76-140.15,79.76-140.15l-79.76-140.15H109.64L29.89,221.85l79.76,140.15Z">
          </path>
          <path class="cls-1"
            d="m264.98,372.35l-166.26-8.84L23.15,213.01,113.82,71.36l166.26,8.84,75.58,150.49-90.67,141.65Zm-165.16-10.54l164.25,8.73,89.58-139.95-74.67-148.68-164.25-8.73L25.15,213.12l74.67,148.68Z">
          </path>
          <path class="cls-1"
            d="m259.2,380.9l-170.66-18.2L18.74,203.66,119.61,62.81l170.66,18.2,69.8,159.04-100.87,140.85Zm-169.48-19.84l168.67,17.99,99.69-139.2-68.98-157.19-168.67-17.99L20.73,203.87l68.98,157.19Z">
          </path>
          <path class="cls-1"
            d="m252.79,389.38l-174.7-28.07L14.7,193.78,126.01,54.32l174.7,28.07,63.39,167.53-111.31,139.46Zm-173.44-29.65l172.72,27.75,110.05-137.88-62.67-165.63-172.72-27.75L16.68,194.1l62.67,165.63Z">
          </path>
          <path class="cls-1"
            d="m245.74,397.77l-178.33-38.46L11.07,183.4,133.06,45.94l178.33,38.46,56.34,175.91-121.99,137.46Zm-176.99-39.97l176.37,38.03,120.65-135.95-55.72-173.98-176.37-38.03L13.03,183.82l55.72,173.98Z">
          </path>
          <path class="cls-1"
            d="m238.04,406.01l-181.52-49.35L7.88,172.51,140.76,37.69l181.52,49.35,48.64,184.16-132.88,134.81Zm-180.11-50.78l179.59,48.82,131.47-133.38-48.12-182.2-179.59-48.82L9.82,173.03l48.12,182.2Z">
          </path>
          <path class="cls-1"
            d="m229.68,414.08l-184.23-60.73L5.18,161.13,149.13,29.63l184.23,60.73,40.27,192.23-143.95,131.5Zm-182.74-62.09l182.32,60.1,142.46-130.14-39.86-190.24L149.55,31.61,7.08,161.75l39.86,190.24Z">
          </path>
          <path class="cls-1"
            d="m220.64,421.93l-.47-.18-185.94-72.41L3,149.26,158.17,21.78l.47.18,185.94,72.41,31.24,200.07-155.17,127.48Zm-184.85-73.87l184.53,71.87,153.61-126.2-30.92-198.07L158.48,23.79,4.87,149.99l30.92,198.07Z">
          </path>
          <path class="cls-1"
            d="m210.91,429.51L22.9,344.58,1.39,136.93,167.89,14.2l188.02,84.93,21.51,207.66-166.5,122.73ZM24.52,343.39l186.19,84.1,164.88-121.54-21.3-205.64L168.1,16.22,3.22,137.75l21.3,205.64Z">
          </path>
          <path class="cls-1"
            d="m200.5,436.79L11.48,339.08l-.03-.51L.38,124.14,178.3,6.92l189.02,97.71.03.51,11.08,214.43-177.92,117.22ZM13.16,337.97l187.24,96.79,176.24-116.11-11-212.9L178.4,8.95,2.16,125.06l11,212.9Z">
          </path>
          <path class="cls-1"
            d="m189.4,443.71L.02,332.78V110.93L189.4,0l189.38,110.93v221.85l-189.38,110.93ZM1.76,331.76l187.64,109.91,187.64-109.91V111.94L189.4,2.03,1.76,111.94v219.82Z">
          </path>
        </g>
        <g>
          <path class="cls-2"
            d="m.29,381.62l40.44,23.21v87.04c13.12-20.04,33.88-29.51,57.93-29.51,47.36,0,64.85,30.97,64.85,80.51v103.47h-40.44v-98.37c0-29.51-8.02-46.63-37.89-46.63-28.05,0-44.45,22.22-44.45,50.28v94.72H.29v-264.72Z">
          </path>
          <path class="cls-2"
            d="m195.56,556.36c0-52.1,33.88-94,83.43-94,24.41,0,45.9,9.84,60.11,26.6v-84.12l40.44-23.21v264.72h-38.62v-22.59c-14.57,16.76-36.8,26.23-61.93,26.23-49.55,0-83.43-41.9-83.43-93.63Zm143.54,0c0-31.7-21.13-55.01-49.91-55.01-30.6,0-52.46,23.32-52.46,55.01s21.86,54.65,52.46,54.65c28.42,0,49.91-22.59,49.91-54.65Z">
          </path>
          <path class="cls-2"
            d="m411.6,452.67l40.44,23.33v15.87c13.48-20.04,34.25-29.51,58.29-29.51,48.82,0,64.85,32.42,64.85,80.51v103.47h-40.44v-98.37c0-29.51-6.56-46.63-36.8-46.63-26.59,0-45.9,20.77-45.9,50.64v94.36h-40.44v-193.67Z">
          </path>
        </g>
      </g>
    </svg>

    <!-- The tabs on the header -->
    <v-tabs centered color="grey darken-1" :hideSlider="this.hideSlider">
      <v-tab v-for="tab in allowedTabs" :key="tab.name" :to="tab.to">
        {{tab.name}}
      </v-tab>
    </v-tabs>
    <!-- The user button -->
    <div class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" v-on="on" class="d-flex align-center">
            <v-avatar color="grey darken-1" size="48">
              <span class="white--text headline">{{ userInitials }}</span>
            </v-avatar>
            <v-icon> mdi-menu-down </v-icon>
            <!-- <v-icon v-else>
              mdi-menu-up
            </v-icon> -->
          </button>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index">
            <div @click="item.click" class="d-flex" style="cursor: pointer">
              <v-icon>
                {{ item.icon }}
              </v-icon>
              <v-list-item-title class="ml-2">
                {{ item.title }}</v-list-item-title>
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
  import {keycloak as Keycloak} from "../main.js";
  import keycloakConstants from "../constants/keycloakConstants";

  export default {
    props: ['hideMenu', 'hideSlider'],
    data() {

      return {
        items: [
          { title: "Gebruikersinstellingen", icon: "mdi-cog", click: this.userSettings },
          { title: "Uitloggen", icon: "mdi-logout", click: this.logout }
        ],
        tabs: [
          { name: "Applicaties", to: "/applicaties", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE] },
          { name: "Authenticaties", to: "/authenticaties", roles: [] },
          { name: "Organisaties", to: "/organisaties", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE, keycloakConstants.ORG_ADMIN, ...keycloakConstants.ALL_ORG_FUNCTIONALITIES] },
          { name: "Gebruikersgroepen", to: "/gebruikersgroepen", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE] },
          { name: "Gebruikers", to: "/gebruikers", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE] },
          { name: "Contactpersonen", to: "/contactpersonen", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE] },
          { name: "Documentatie", to: "/gebruikersinstellingen/documentatie", roles: [keycloakConstants.DOCUMENTATION_ACCESS]},
          { name: "UitzonderingenLijst", to: "/uitzonderingenlijst", roles: [keycloakConstants.HDN_ADMIN, keycloakConstants.HDN_INZAGE, keycloakConstants.UITZONDERINGENLIJST_ADMIN]}
        ],
      };
    },
    computed: {
      /**
       * Returns the userInitials to be displayed in the top right of the screen.
       * 
       * keycloakName is the name, preferred_username from the keycloak parsed token or sets it to an empty string
       * if both are undefined/null.
       * 
       * It the returns the first and last name initials of the keycloakName in uppercase. If there is only one name
       * that initial is returned instead.
       */
      userInitials() {
        let keycloakName = Keycloak?.tokenParsed?.name ?? Keycloak?.tokenParsed?.preferred_username ?? '';
        let splitKeycloakName = keycloakName.split(" ");
        let userInitials = "";

        //If multiple names then return first letter of first and last name otherwise take first letter
        if (splitKeycloakName.length > 1) {
          userInitials = splitKeycloakName[0].charAt(0) + splitKeycloakName[splitKeycloakName.length - 1].charAt(0);
        } else {
          userInitials = splitKeycloakName[0].charAt(0);
        }

        return userInitials.toUpperCase();
      },
      //Filter to show only the tabs that includes the roles in your Keycloak token.
      allowedTabs() {
        if (this.hideMenu) {
          return {};
        }

        return this.tabs.filter(
          (tab) => Keycloak.tokenParsed.resource_access[keycloakConstants.USERMANAGEMENT_REALM_NAME]?.roles.some(e => tab.roles.includes(e))
        );
      }
    },
    methods: {
      logout() {
        localStorage.clear();
        Keycloak.logout();
      },
      userSettings() {
        this.$router.push({ name: 'gebruikersgegevens' }).catch(() => { });
      },
    },
  };
</script>
<style>
  .cls-1 {
    fill: #fdc100;
  }

  .cls-2 {
    fill: #454d5b;
  }
</style>